import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import SelectField from "../common/SelectField";
import API from "../../config/axios";
import { api_paths } from "../../config/api.paths";
import { toastErrorMessage, toastSuccessMessage } from "../../utils/utils";
import { validateData, clearError } from "../../validators/YupValidations";
import { editMobileSchema } from "../../validators/validatorSchema";
import { useDispatch } from "react-redux";
import { SET_LOADING } from "../../redux/user";
import VerifyOtpAndResetPassword from "./VerifyOtpAndResetPasswordModal";
import { formatUSPhone, normalizePhoneForSave } from "../../utils/phoneFormat";

const ForgotPassword = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    phone: "",
    country_code: "+1",
  });

  const [errors, setErrors] = useState({});
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const [otpId, setOtpId] = useState(null);

  const countryCodeOptions = [
    { value: "+1", label: "+1" },
    { value: "+91", label: "+91" },
  ];

  useEffect(() => {
    if (isOpen) {
      setForm({
        phone: "",
        country_code: "+1",
      });
      setErrors({});
    }
  }, [isOpen]);

  // const handleChange = (field, value) => {
  //   setForm({ ...form, [field]: value });
  //   if (errors[field]) clearError(setErrors, field);
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const isValid = await validateData(editMobileSchema, form, setErrors);
  //   if (!isValid) return;

  //   const payload = {
  //     phone: form.phone,
  //     country_code: form.country_code,
  //   };

  //   try {
  //     dispatch(SET_LOADING(true));

  //     const res = await API.post(api_paths.auth.FORGOT_PASSWORD, payload);

  //     if (res.data?.payload?.result) {
  //       setOtpId(res.data.payload.result);
  //       toastSuccessMessage(res.data.message);
  //       setIsResetModalOpen(true);
  //     }
  //   } catch (error) {
  //     toastErrorMessage(error?.response?.data?.message);
  //   } finally {
  //     dispatch(SET_LOADING(false));
  //   }
  // };

  const handleChange = (field, value) => {
    if (field === "phone") {
      if (form.country_code === "+1") {
        // keep max 10 digits
        const digits = value.replace(/\D/g, "").slice(0, 10);
        value = formatUSPhone(digits); // format for display
      } else {
        value = value.replace(/\D/g, "").slice(0, 15); // other countries: digits only
      }
    }

    setForm((prev) => ({ ...prev, [field]: value }));

    if (errors[field]) clearError(setErrors, field);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formForValidation = {
      ...form,
      phone:
        form.country_code === "+1"
          ? normalizePhoneForSave(form.phone)
          : form.phone.replace(/\D/g, ""),
    };

    const isValid = await validateData(
      editMobileSchema,
      formForValidation,
      setErrors
    );
    if (!isValid) return;

    try {
      dispatch(SET_LOADING(true));

      const payload = {
        phone: formForValidation.phone,
        country_code: form.country_code,
      };

      const res = await API.post(api_paths.auth.FORGOT_PASSWORD, payload);

      if (res.data?.payload?.result) {
        setOtpId(res.data.payload.result);
        toastSuccessMessage(res.data.message);
        setIsResetModalOpen(true);
      }
    } catch (error) {
      toastErrorMessage(error?.response?.data?.message);
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  // VERIFY OTP
  const handleVerifyOtp = async (otp, password) => {
    try {
      dispatch(SET_LOADING(true));

      const res = await API.post(api_paths.auth.VERIFY_FORGOT_PASSWORD_OTP, {
        otp,
        otp_id: otpId,
        new_password: password,
      });

      toastSuccessMessage(res.data.message);
      setIsResetModalOpen(false);
      onClose();
    } catch (error) {
      toastErrorMessage(error?.response?.data?.message);
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  // RESEND OTP
  const handleResendOtp = async () => {
    try {
      dispatch(SET_LOADING(true));

      const response = await API.post(
        `${api_paths.auth.RESEND_OTP}?type=forgot_password`,
        {
          otp_id: otpId,
        }
      );

      if (response.data?.payload?.result) {
        toastSuccessMessage(response?.data?.message);
      }
    } catch (error) {
      toastErrorMessage(error?.response?.data?.message);
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  return (
    <>
      {/* FORGOT PASSWORD MODAL */}
      <Modal show={isOpen} onHide={onClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center fw-semibold update-mo-title">
            Forgot Password
          </Modal.Title>
        </Modal.Header>

        <form onSubmit={handleSubmit}>
          <Modal.Body className="pt-3 px-4 pb-4">
            <label className="small fw-semibold mb-2">Mobile Number</label>

            <div className="d-flex gap-2">
              {/* Country Code */}
              <div style={{ width: "100px" }}>
                {/* <SelectField
                  value={countryCodeOptions.find(
                    (opt) => opt.value === form.country_code
                  )}
                  options={countryCodeOptions}
                  onChange={(opt) => handleChange("country_code", opt.value)}
                /> */}

                <SelectField
                  value={countryCodeOptions.find(
                    (opt) => opt.value === form.country_code
                  )}
                  options={countryCodeOptions}
                  onChange={(opt) => {
                    const newCode = opt.value;
                    setForm((prev) => ({
                      ...prev,
                      country_code: newCode,
                      phone:
                        newCode === "+1"
                          ? formatUSPhone(normalizePhoneForSave(prev.phone))
                          : prev.phone.replace(/\D/g, ""),
                    }));
                  }}
                />
              </div>

              {/* Phone Number */}
              <div className="flex-grow-1">
                <input
                  type="tel"
                  placeholder="Enter Mobile Number"
                  className={`form-control form-control-sm ${
                    errors.phone ? "is-invalid" : ""
                  }`}
                  value={form.phone}
                  onChange={(e) => handleChange("phone", e.target.value)}
                  maxLength={form.country_code === "+1" ? 15 : 10}
                />
                {errors.phone && (
                  <div className="invalid-feedback d-block">
                    {errors.phone.message}
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className="border-0 px-4 pb-4">
            <Button
              type="submit"
              className="w-100 btn-orange-lg"
              style={{
                backgroundColor: "#F4A528",
                border: "none",
                fontWeight: 600,
                fontSize: "16px",
                borderRadius: "8px",
              }}
            >
              Send OTP
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      {/* OTP VERIFY MODAL */}
      <VerifyOtpAndResetPassword
        isOpen={isResetModalOpen}
        onClose={() => setIsResetModalOpen(false)}
        otp_id={otpId}
        onResend={handleResendOtp}
        onVerifyReset={(otp, password) => handleVerifyOtp(otp, password)}
      />
    </>
  );
};

export default ForgotPassword;
